###
# Модель ресторана
###
App.Restaurant = DS.Model.extend
  session           : Em.inject.service('session')

  name              : DS.attr 'string'
  phone             : DS.attr 'string'
  is_running        : DS.attr 'boolean'
  closed_till       : DS.attr 'date'
  closed_message    : DS.attr 'string'
  city              : DS.attr 'string'
  address           : DS.attr 'string'
  address_comment   : DS.attr 'string'
  description       : DS.attr 'string'
  is_delivery       : DS.attr 'boolean'

  timezone          : DS.attr 'string'
  timezone_own      : DS.attr 'string'

  external_id       : DS.attr 'string'
  terminal_id       : DS.attr 'string'
  uses_pos          : DS.attr 'boolean'

  is_rush_mode      : DS.attr 'boolean'

  latitude:  DS.attr 'number'
  longitude: DS.attr 'number'

  timezone:  DS.attr 'string'

  tables         : DS.hasMany 'table',          async : true
  delivery_zones : DS.hasMany 'delivery_zone',  async: true

  parent : DS.belongsTo 'restaurant', async: false, inverse: 'children'
  children : DS.hasMany 'restaurant', async: true, inverse: 'parent'

  hasCoordinates: Em.computed 'latitude', 'longitude', ->
    !Em.isBlank(@get('latitude')) and !Em.isBlank(@get('longitude'))

  isReadyToDrawOnMap: Ember.computed.alias('hasCoordinates')

  pinIcon: L.icon
    iconUrl: 'images/map-markers/restaurant-marker.png'
    iconSize:    [28, 42]
    iconAnchor:  [14, 42]
    popupAnchor: [0, -26]

  markerIcon: L.icon
    iconUrl: 'images/map-markers/restaurant-marker-round.png'
    iconSize: [52, 52]
    iconAnchor: [26, 26]
    popupAnchor: [0, -26]

  # Внешние связи
  organization      : DS.belongsTo 'organization', async: true

  noParent: (->
    if @get('session.currentUser.account.isAdmin')
      return Ember.isEmpty(@get('parent'))
    true
  ).property('parent', 'session.currentUser.account.isAdmin')

  geocode: ->
    @nonRESTAction('POST', 'geocode')

  nameWithRush: (->
    if @get('is_rush_mode')
      " 🔥 #{@get 'name'}"
    else
      @get 'name'
  ).property('is_rush_mode')

  nameWithOrganization: (->
    return @get('name') unless @get('session.isLC')
    [@get('organization.name'), @get('name')].join(': ')
  ).property('name', 'organization.name')

  availability: (->
    av = @get('cached_availability')
    return av if av
    @nonRESTAction('GET', 'availability')
      .then (result) =>
        aa = {}
        result.availabilities.forEach (a) ->
          aa[a.dish_id] = a
        @set('cached_availability', aa)
        @notifyPropertyChange('availability')

  ).property('cached_availability')
